<template>
  <div class="grid-column-1-2" id="treatment-section">
    <hash-tag-card
      v-if="!isTreatmentSection"
      :hashtagItems="doctor.hashtag_item_structure"
      :has-permission="hasAdvPermission"
      :dentcoIcons="dentcoIcons"
      @edit="isTreatmentSection = true"
    />
    <treatment-section-adv-form
      v-if="hasAdvPermission && isTreatmentSection"
      :show.sync="isTreatmentSection"
      :doctor="doctor"
      :dentcoIcons="dentcoIcons"
      @update="onUpdate"
    />
    <treatment-section-free-form
      v-if="!hasAdvPermission && isTreatmentSection"
      :show.sync="isTreatmentSection"
      :doctor="doctor"
      @update="onUpdate"
    />
  </div>
</template>

<script>
import HashTagCard from "@/components/settings/doctor/v2/adv/HashTagCard.vue";
import TreatmentSectionAdvForm from "@/components/settings/doctor/v2/TreatmentSectionAdvForm.vue";
import TreatmentSectionFreeForm from "@/components/settings/doctor/v2/TreatmentSectionFreeForm.vue";

export default {
  name: "DoctorTreatmentSection",

  components: {
    HashTagCard,
    TreatmentSectionAdvForm,
    TreatmentSectionFreeForm,
  },

  props: {
    doctor: {
      type: Object,
      required: true,
    },
    dentcoIcons: {
      type: Array,
      default: () => [],
    },
    hasAdvPermission: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isTreatmentSection: false,
    };
  },

  methods: {
    onUpdate(payload) {
      this.$emit("update-hashtag", payload);
    },
  },
};
</script>
